export const appConfig =
  (typeof window !== "undefined" && window.SERPBACKLINK_CONFIG) || {};
